import TFM from 'app/scripts/lib/markdown/tfm';
import { Analytics } from '@trello/atlassian-analytics';
import { sendErrorEvent } from '@trello/error-reporting';
import { featureFlagClient } from '@trello/feature-flag-client';

interface MarkdownInfoType {
  rule: string;
}

interface MarkdownTypeCountType {
  [key: string]: number;
}

type AnalyzeFnType = (text: string) => [MarkdownInfoType];

interface MarkdownTFMAnalyzeMapType {
  description: { analyze: AnalyzeFnType };
  checkItems: { analyze: AnalyzeFnType };
  comments: { analyze: AnalyzeFnType };
}

type MarkdownLocationType = keyof MarkdownTFMAnalyzeMapType;

const markdownTFMAnalyzeMap: MarkdownTFMAnalyzeMapType = {
  description: TFM.description,
  checkItems: TFM.checkItems,
  comments: TFM.comments,
};

export const markdownTracker = (
  inputValue: string,
  type: MarkdownLocationType,
) => {
  if (!inputValue) {
    return;
  }
  if (!featureFlagClient.get('aaaa.web.trello-markdown-tracking', false)) {
    return;
  }
  try {
    const start = Date.now();

    if (markdownTFMAnalyzeMap[type]) {
      const markdownTFMAnalyzeFn = markdownTFMAnalyzeMap[type];
      const markdownData: MarkdownInfoType[] =
        markdownTFMAnalyzeFn.analyze(inputValue ?? '') || [];

      const markdownTypeCount: MarkdownTypeCountType = {};
      const filteredMarkdownData = markdownData.filter((markdownInfo) => {
        const { rule } = markdownInfo;
        return rule !== 'paragraph' && rule !== 'text';
      });

      if (filteredMarkdownData.length > 0) {
        filteredMarkdownData.forEach((markdownInfo) => {
          const { rule } = markdownInfo;

          if (!Object.hasOwnProperty.call(markdownTypeCount, rule)) {
            markdownTypeCount[rule] = 0;
          }

          markdownTypeCount[rule] = markdownTypeCount[rule] + 1;
        });

        Analytics.sendOperationalEvent({
          action: 'updated',
          actionSubject: 'trackMarkdown',
          source: 'lib:markdownTracker',
          attributes: {
            markdownTypeCount,
            markdownLocation: type,
          },
        });
      }
    }

    const end = Date.now();

    Analytics.sendOperationalEvent({
      action: 'completed',
      actionSubject: 'trackMarkdown',
      source: 'lib:markdownTracker',
      attributes: {
        totalProcessTimeInMs: end - start,
      },
    });
  } catch (err) {
    sendErrorEvent(err, {
      tags: {
        ownershipArea: 'trello-aaaa',
        feature: 'Markdown Tracker',
      },
    });
  }
};
